import { router } from 'expo-router';
import React from 'react';
import { StyleSheet, View } from 'react-native';

import useMyIntroById from '@hooks/useMyIntroById';
import IntroRequestCard from '@molecules/IntroRequestCard';
import { useGetProfile } from '@sunrise-ui/api-client';
import { withAuthGate } from '@sunrise-ui/composites';
import {
  PageHeader,
  useDynamicStyles,
  useSafeLocalSearchParams,
  type WithResponsive,
} from '@sunrise-ui/primitives';
import IntroPrepView from '@templates/IntroPrepView';

function IntroPrepScreen() {
  const styles = useDynamicStyles(createStyles);

  const { introId } = useSafeLocalSearchParams<{ introId: string }>();
  const { otherUserHalf } = useMyIntroById({ introId });

  const { data: otherUser } = useGetProfile(otherUserHalf?.person.user_id);
  if (!otherUserHalf || !otherUser) return null;

  const pageHeader = (
    <PageHeader
      header="Let's record your intro video."
      subheader={`${otherUser.first_name} ${otherUser.last_name} will watch this 20s video to decide whether to meet you.`}
    />
  );

  const onPressRecord = () => {
    router.navigate(`/intros/myIntros/record/${introId}`);
  };

  return (
    <IntroPrepView
      page="intro"
      onPressRecord={onPressRecord}
      pageHeader={pageHeader}
    >
      <View style={styles.introRequestCardContainer}>
        <IntroRequestCard introId={introId} />
      </View>
    </IntroPrepView>
  );
}

const createStyles = ({ isTablet, isDesktop }: WithResponsive) =>
  StyleSheet.create({
    introRequestCardContainer: {
      flexShrink: isTablet || isDesktop ? 1 : undefined,
    },
  });

export default withAuthGate(IntroPrepScreen);
